export function getTitle(state, tabIndex) {
  let selectedTab = tabIndex != null ? tabIndex : state.selectedTab;
  return state.tabs[selectedTab].title;
}
